import { Table, Tag } from 'antd';
import styled, { css } from 'styled-components';

export const CTable = styled(Table)`
  .ant-table-body {
    ::-webkit-scrollbar {
      display: none;
    }
    height: 318px;
  }
  .ant-table-cell {
    padding: 6px 0;
  }
  .ant-pagination {
    margin-top: 16px;
    margin-bottom: 0;
    > li {
      min-width: 23px;
      height: 23px;
      line-height: 22px;
      .ant-select > .ant-select-selector {
        min-width: 22px;
        height: 23px;
        line-height: 22px;
        > .ant-select-selection-item {
          line-height: 22px;
        }
      }
      .ant-select > .ant-select-arrow {
        margin-top: -4px;
      }
    }
  }
`;

export const CTag = styled(Tag)`
  padding: 4px 8px;
  border-radius: 6px;
  border: 0;
  background-color: #ffffff;
  color: ${props => props.theme.colors.primary.main};
  font-size: ${props => props.theme.font.size.xs};
  margin: 0 !important;

  position: relative;

  &::before {
    content: ' ';
    width: 100%;
    height: 100%;
    background: ${props => props.theme.colors.primary.main};

    opacity: 0.1;
    pointer-events: auto;
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const WrapListParent = styled.div`
  width: 100%;
  height: calc(100vh - 330px);
  overflow-y: scroll;
  box-shadow: 0 0 8px -8px #f1f1f1;
  ::-webkit-scrollbar {
    width: 6px;
    background: transparent !important;
    display: none;
  }
`;

export const WrapList = styled.div`
  height: calc(100vh - 330px);
  overflow-y: scroll;

  ::-webkit-scrollbar {
    width: 6px;
    background: transparent !important;
    display: none;
  }
`;

export const WrapCheckBox = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

export const WrapCheckBoxParent = styled.div`
  display: flex;
  align-items: center;
`;

export const Image = styled.img`
  height: 48px;
  width: 48px;
  border-radius: 6px;
  object-fit: cover;
  flex-shrink: 0;
`;

export const SkeletonStyles = css`
  .ant-skeleton {
    width: 100%;
  }
`;
